import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React from "react";

function LandingPageFeature({
  title,
  image,
  text,
  careers,
  invite,
  lend,
  outline,
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      height="100%"
      textAlign="center"
      className="cursor-pointer"
      // justifyContent={`${careers ? "space-evenly" : "space-between"}`}
      justifyContent={`${careers ? "space-evenly" : null}`}
    >
      {image ? (
        <img
          className={classes.featureImage}
          style={careers ? { width: "100px", height: "auto" } : null}
          src={image}
          alt="features"
        />
      ) : null}

      {!careers ? (
        lend ? (
          <div className="mb-14 md:mt-10 md:mb-20">
            <p>
              <span
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "bold",
                  fontSize: "35px",
                }}
              >
                {title} <br></br>
              </span>
              APY
            </p>
            <p>Interest Rate</p>
          </div>
        ) : (
          <Typography variant="h6" style={{ margin: "0px 10px" }}>
            <strong>{title}</strong>
          </Typography>
        )
      ) : (
        <Typography
          variant="h6"
          // style={{ color: invite ? theme.palette.primary.main : null }}
          style={
            invite
              ? { color: theme.palette.primary.main, fontWeight: "bold" }
              : null
          }
        >
          {title}
        </Typography>
      )}

      {!careers ? (
        lend ? (
          <Button
            variant={outline ? "contained" : "outlined"}
            color="primary"
            className={`-mt-8  normal-case ${
              outline ? "bg-primary text-white font-bold" : "dark:text-white "
            }`}
            style={{
              border: "1px solid #44CBB3",
              borderRadius: "20px",
              width: "90%",
              height: "50px",
            }}
          >
            {text}
          </Button>
        ) : (
          <Typography variant="body1">
            <strong>{text}</strong>
          </Typography>
        )
      ) : (
        <Typography variant="body1" className="text-sm">
          {text}
        </Typography>
      )}
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  featureImage: {
    marginBottom: "20px",
    height: "auto",
    width: "200px",
    [theme.breakpoints.down("md")]: {
      height: "auto",
      width: "130px",
      marginBottom: "0",
    },
  },
}));

export default LandingPageFeature;
